__turbopack_context__.v({
  "ack": "feed-view-module__PsTnqq__ack",
  "action": "feed-view-module__PsTnqq__action",
  "actor": "feed-view-module__PsTnqq__actor",
  "askWhere": "feed-view-module__PsTnqq__askWhere",
  "burstSummary": "feed-view-module__PsTnqq__burstSummary",
  "controls": "feed-view-module__PsTnqq__controls",
  "decisionActions": "feed-view-module__PsTnqq__decisionActions",
  "detailLink": "feed-view-module__PsTnqq__detailLink",
  "empty": "feed-view-module__PsTnqq__empty",
  "emptyIcon": "feed-view-module__PsTnqq__emptyIcon",
  "event": "feed-view-module__PsTnqq__event",
  "feed": "feed-view-module__PsTnqq__feed",
  "itemGone": "feed-view-module__PsTnqq__itemGone",
  "itemLink": "feed-view-module__PsTnqq__itemLink",
  "list": "feed-view-module__PsTnqq__list",
  "main": "feed-view-module__PsTnqq__main",
  "notice": "feed-view-module__PsTnqq__notice",
  "notify": "feed-view-module__PsTnqq__notify",
  "offerFoot": "feed-view-module__PsTnqq__offerFoot",
  "offerTime": "feed-view-module__PsTnqq__offerTime",
  "row": "feed-view-module__PsTnqq__row",
  "rowLink": "feed-view-module__PsTnqq__rowLink",
  "sentence": "feed-view-module__PsTnqq__sentence",
  "toolbar": "feed-view-module__PsTnqq__toolbar",
  "unread": "feed-view-module__PsTnqq__unread",
});
